import React,{useState,useEffect} from 'react';
import Sanavbar from '../Components/Sanavbar';
import Sasidebar from '../Components/Sasidebar';
import SausersMain from '../Components/SausersMain';

const Superusers = () => {
  const[sidebar,setSidebarOpen]= useState(false);

  const togglesidebar =()=> {
    setSidebarOpen((prevState) => !prevState)
  }
  useEffect(()=>{const venture = localStorage.getItem('ventureid');
  if(venture!=='00'){document.getElementById("SA-dashboard").style.display="none"}
  else{ document.getElementById("SA-dashboard").style.display="grid"}
 },[]);
      return (
          <div className='super-container' id='SA-dashboard'>
          <Sanavbar sidebar={sidebar} openSidebar={togglesidebar}/>
          <Sasidebar sidebar={sidebar} />
          <SausersMain/>
    
        </div>
      );
}

export default Superusers